export const phone = '931-308-0649';
export const email = 'astephens@sabertn.com';
export const vendorEmail = 'mrussell@sabertn.com';
export const city = 'Nashville, Tennessee';
export const duns = '11-921-7866';
export const cage = '9UQZ9';

export const naics = [
  { code: '236220', label: 'General Construction' },
  { code: '236210', label: 'Factory / Warehouse Construction' },
  { code: '238160', label: 'Roofing Contractors' },
  { code: '238330', label: 'Flooring Contractors' },
  { code: '238120', label: 'Structural Steel & Concrete Contractors' },
  { code: '238320', label: 'Painting Contractors' },
];
